import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import React, { Fragment, useEffect, useState } from "react";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  BulkDeleteButton,
  FunctionField,
  SelectInput,
  useNotify,
  useMutation,
  useRefresh,
  ListProps,
  BulkActionProps,
} from "react-admin";
import { Helmet } from "react-helmet";
import FormatAlignJustifyIcon from "@material-ui/icons/FormatAlignJustify";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import _ from "lodash";
import { statusList } from "./const";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { getUserIdFilterBasedOnRole } from "utils/tools";

const SchoolFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const BulkActionButtons = (props: BulkActionProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
  </Fragment>
);

const MenuListButton = (props: ISchool) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [statusSchool, setStatusSchool] = useState<string>("");

  let inversedStatus: string = statusSchool;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    //inverse the School Status for showing in MenuList
    props.status === "Active"
      ? setStatusSchool("Inactive")
      : setStatusSchool("Active");
  }, [props.status]);

  const ChangeStatusSchoolDialog = (props: ISchool) => {
    const [open, setOpen] = React.useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const [handleChangeStatusSchool, { loading }] = useMutation(
      {
        type: "update",
        resource: "schools",
        payload: {
          id: props.id,
          data: { ...props, status: _.toLower(inversedStatus) },
        },
      },
      {
        onSuccess: ({ data }) => {
          notify(`Successfully change status school.`, "info");
          refresh();
        },
        onFailure: (error) =>
          notify(`Failed change status, error: ${error.message}`, "warning"),
      }
    );

    const handleOpenStatusSchoolDialog = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <>
        <MenuItem onClick={handleOpenStatusSchoolDialog}>
          {statusSchool}
        </MenuItem>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Change School Status"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" color="initial">
              Are you sure to changes the School Status from "
              {_.upperFirst(props.status)}" to "{inversedStatus}" ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Back
            </Button>
            <Button
              onClick={handleChangeStatusSchool}
              color="primary"
              disabled={loading}
              autoFocus
            >
              {loading ? "Please wait..." : "Confirm"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  return (
    <div>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <FormatAlignJustifyIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <ChangeStatusSchoolDialog {...props} />
      </Menu>
    </div>
  );
};

const SchoolList = (props: ListProps) => {
  const SchoolShowButton = (record: ISchool) => {
    return (
      <Button href={`/#/schools/${record.id}/show`}>
        <VisibilityIcon />
      </Button>
    );
  };

  const SchoolEditButton = (record: ISchool) => (
    <Button href={`/#/schools/${record.id}`}>
      <EditIcon />
    </Button>
  );

  return (
    <>
      <Helmet>
        <title>Schools</title>
      </Helmet>
      <List
        exporter={false}
        filters={<SchoolFilter />}
        filter={getUserIdFilterBasedOnRole()}
        bulkActionButtons={<BulkActionButtons />}
        {...props}
      >
        <Datagrid>
          <FunctionField
            label="School Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>

                  <TextField source="id" emptyText="-" />
                </Grid>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>

                  <TextField source="name" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>

                  <TextField source="email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Contact No. :
                  </Typography>

                  <TextField source="phone" emptyText="-" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <FunctionField
            label="Address"
            render={(record: any) => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Block No. :
                  </Typography>

                  <TextField source="blockNumber" emptyText="-" />
                </Grid>

                {record.address !== null && (
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Address :
                    </Typography>

                    <TextField source="address" emptyText="-" />
                  </Grid>
                )}

                {record.unitNumber !== null && (
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Unit No. :
                    </Typography>

                    <TextField source="unitNumber" emptyText="-" />
                  </Grid>
                )}

                {record.building !== null && (
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Building Name :
                    </Typography>

                    <TextField source="building" emptyText="-" />
                  </Grid>
                )}

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Postal Code :
                  </Typography>

                  <TextField source="postalCode" emptyText="-" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <CustomDateField source="createdAt" isDateTime />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(props: any) => (
              <>
                <SchoolShowButton {...props} />
                <SchoolEditButton {...props} />
              </>
            )}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default SchoolList;
